import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../hooks/useAuth';
import './Header.css';

export function Header() {
  const { user, isAuthenticated, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    }

    if (showUserMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showUserMenu]);

  const handleLogout = () => {
    setShowUserMenu(false);
    logout();
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          Pool Tournament Manager
        </Link>

        <nav className="header-nav">
          <Link to="/competitions" className="header-nav-link">
            Competitions
          </Link>
          <Link to="/standings" className="header-nav-link">
            Standings
          </Link>
          <Link to="/fixtures" className="header-nav-link">
            Fixtures
          </Link>
          <Link to="/results" className="header-nav-link">
            Results
          </Link>
          <Link to="/app" className="header-nav-link header-app-link">
            App
          </Link>

          {isAuthenticated ? (
            <>
              {user?.role === 'Captain' && (
                <Link to="/captain/dashboard" className="header-nav-link">
                  My Dashboard
                </Link>
              )}
              {user?.role === 'Organizer' && (
                <Link to="/organizer/dashboard" className="header-nav-link">
                  Organiser
                </Link>
              )}
            </>
          ) : (
            <Link to="/login" className="header-nav-link header-login">
              Login
            </Link>
          )}
        </nav>

        {isAuthenticated && (
          <div className="user-menu-container" ref={menuRef}>
            <button 
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="user-menu-button"
              aria-expanded={showUserMenu}
              aria-haspopup="true"
            >
              <span className="user-icon">👤</span>
              <span className="user-name">{user?.name || user?.email}</span>
              <span className="user-menu-arrow">{showUserMenu ? '▲' : '▼'}</span>
            </button>
            {showUserMenu && (
              <div className="user-menu-dropdown">
                <div className="user-menu-header">
                  <div className="user-menu-name">{user?.name || 'User'}</div>
                  <div className="user-menu-email">{user?.email}</div>
                  <div className="user-menu-role">{user?.role}</div>
                </div>
                <div className="user-menu-divider"></div>
                <button onClick={handleLogout} className="user-menu-logout">
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
}
